import { useEffect, useState } from 'react';
import RoleService from '../../../services/role_service';

const Roles = ({ logout, message }) => {
  const [roles, setRoles] = useState([]);

  const loadRoles = async () => {
    try {
      const result = await RoleService.getAll();
      if (logout(result)) return;
      setRoles((result || []).filter((rol) => rol?.Name !== 'Super Administrador'));
    } catch (e) {
      message(e?.message || e, 'error');
    }
  }

  useEffect(() => {loadRoles()}, []);

  return { roles };
};

export default Roles;
